:host {
  position: relative;
  font-family: system-ui;
  float: inherit;

  width: fit-content;
  height: fit-content;
}
